import { BaseDto } from "src/dtos/common/baseDto";
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";

export interface SYS4030_R01Dto extends WareHouseDto {
	customNm: string;
}

export const defaultSYS4030_R01Dto: SYS4030_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	warehouseCd: '',
	warehouseNm: '',
	displaySeq: 0,
	inoutType: '',
	logicCenter: '',
	compCd: '',
	customCd: '',
	customNm: '',
	materialYn: 'N',
	goodsYn: 'N',
	productYn: 'N',
	manufactYn: 'N',
	badYn: 'N',
	fifiYn: 'N',
	useYn: 'N',
	approveFlg: 'N',
	remark: '',

	inserted: false,
	isModified: false
}